<template>
  <div id="investor">
    <big-title>
      Mis <span>movimientos</span>.
    </big-title>

    <vx-card v-if="isMounted && !failed" title="Escoge el periodo que deseas consultar:">
      <div class="vx-row mt-4">
        <div class="vx-col w-full mb-3">
          <ul class="centerx options-display">
            <li class="mr-6">
              <vs-radio color="success" v-model="periodType" vs-value="current">Mes actual</vs-radio>
            </li>
            <li class="mr-6">
              <vs-radio v-model="periodType" vs-value="last">Mes anterior</vs-radio>
            </li>
            <li class="mr-6">
              <vs-radio color="success" v-model="periodType" vs-value="custom">Personalizado</vs-radio>
            </li>
          </ul>
        </div>
      </div>

      <div class="vx-row" v-if="onCustomPeriod">
        <div class="vx-col sm:w-1/5 w-full mb-4">
          <label class="vs-input--label">Fecha de inicio</label>
          <datepicker placeholder="Fecha inicio" :language="es" v-model="startDate" format="dd/MM/yyyy"
            :disabledDates="disabledDates" />
        </div>
        <div class="vx-col sm:w-1/5 w-full mb-4">
          <label class="vs-input--label">Fecha de término:</label>
          <datepicker placeholder="Fecha final" :language="es" v-model="endDate" format="dd/MM/yyyy"
            :disabledDates="disabledDates" />
        </div>
        <div class="vx-col sm:w-3/5 w-full mb-4 flex">
          <vs-button @click="datesChanged" color="primary" style="height: 40px"
            class="mt-6 mr-1 px-3">Consultar</vs-button>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col w-full mb-3">
          <label class="bold">Consulta el detalle de tus movimientos del {{ currentPeriodFormat }} con este
            reporte:</label>
          <vs-button color="primary" icon-pack="feather" type="border" icon="icon-download" :disabled="allMovements.length == 0" style="height: 40px"
            @click="downloadCSV">Descargar movimientos</vs-button>
        </div>
      </div>

      <div class="mt-6 mb-6">
        <div class="flex md:items-end items-center justify-between flex-wrap">
          <!--p class="lg:inline-flex bold black text-3xl mr-4">Tus semillas y girasoles </p-->

          <div class="flex justify-between items-end flex-grow">
            <div class="flex flex-wrap">
              <p v-if="isMounted && isMobileScreen"
                class="px-6 py-2 mb-3 text-primary bold border-2 border-primary border-solid rounded-lg">Total de
                movimientos: {{ allMovements.length }}</p>

              <vs-dropdown v-if="isMounted" vs-trigger-click class="cursor-pointer mr-6 items-per-page-handler">
                <div
                  class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">Mostrando {{ currentItemsPage * itemsPerPage - (itemsPerPage - 1) }} - {{
                    allMovements.length - currentItemsPage * itemsPerPage > 0 ? currentItemsPage * itemsPerPage :
                      allMovements.length }} de {{ queriedItems }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item v-for="it in itemsPerPageDefinitions" @click="itemsPerPage = it" :key="it">
                    <span>{{ it }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <p v-if="isMounted && !isMobileScreen"
                class="px-6 py-2 text-primary bold border-2 border-primary border-solid rounded-lg">{{ allMovements.length
                }}
                movimientos en total</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista Tabla -->
      <div id="data-list-thumb-view" class="data-list-container" v-if="currentItemView === 'item-list-view'">
        <vx-pagination :total="totalPages" v-model="currentx" v-if="isMobileScreen"></vx-pagination>
        <vs-table :sst="true" class="mt-4" ref="table" :data="currentMovements" :max-items="itemsPerPage"
          noDataText="No hay registros">
          <template slot="thead">
            <vs-th class="bold " sort-key="date">FECHA</vs-th>
            <vs-th class="bold" sort-key="concept">CONCEPTO</vs-th>
            <vs-th class="bold" sort-key="amount">MONTO</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="font-medium">{{ regularDateFormat(tr.date) }}</p>
                </vs-td>
                <vs-td>
                    <div class="flex flex-wrap">
                      {{ tr.concept }}
                      <template v-if="tr.voucheable">
                        <vx-tooltip text="Descargar comprobante">
                          <feather-icon
                          class="ml-5"
                          icon="DownloadIcon"
                          svgClasses="h-5 w-5 stroke-current hover:text-primary cursor-pointer"
                          @click.stop="downloadVoucherRequest(tr)"/>
                        </vx-tooltip>
                      </template>
                    </div>
                </vs-td>
                <vs-td>
                  <p v-if="tr.operation_type == 'plus'" class='font-medium bold text-success'>{{ explicitMoneyFormat(tr.amount) }}</p>
                  <p v-else class='font-medium bold text-dark'>{{ explicitMoneyFormat(tr.amount) }}</p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
        <br>
        <vx-pagination :total="totalPages" v-model="currentx"></vx-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
import formatHelper from '@mixins/formatHelper';
import dateHelper from '@mixins/dateHelper';
import Datepicker from 'vuejs-datepicker';
import { es } from "vuejs-datepicker/dist/locale";
import VxPagination from "@/vx-components/vx-pagination/VxPagination";

export default {
  mixins: [formatHelper, dateHelper],
  components: {
    Datepicker,
    VxPagination
  },
  async mounted() {
    this.setInitialDates();
    await this.loadMovements();
  },
  data() {
    return {
      periodType: 'current',
      currentItemView: 'item-list-view',
      itemsPerPage: 25,
      itemsPerPageDefinitions: [25, 50],
      mobileScreen: 576,
      date: new Date(),
      isFirstTime: true,
      es: es,
      allMovements: [],
      startDate: null,
      endDate: null,
      isMounted: false,
      loading: false,
      failed: false,
      disabledDates: {
        from: new Date()
      },
      currentx: 1,
      maxRangeDays: 90,
      isInvalidRange: false,
      rangeError: "El rango de tiempo máximo para consulta o descarga es de 3 meses.",
    };
  },
  computed: {
    currentPeriodFormat() {
      if (!this.isMounted) {
        return "";
      }
      if (this.onCurrentPeriod) {
        return `mes actual`
      }
      else if (this.onCustomPeriod) {
        return `periodo personalizado`
      }
      else if (this.onLastPeriod) {
        return "mes anterior";
      }
    },
    onCurrentPeriod() {
      return this.periodType === 'current';
    },
    onLastPeriod() {
      return this.periodType === 'last';
    },
    onCustomPeriod() {
      return this.periodType === 'custom';
    },
    totalPages() {
      return Math.ceil(this.allMovements.length / this.itemsPerPage);
    },
    isMobileScreen() {
      return this.$store.state.windowWidth <= this.mobileScreen
    },
    currentMovements() {
      let cmin = ((this.currentx - 1) * this.itemsPerPage);
      let cmax = (cmin + this.itemsPerPage);
      return this.allMovements.slice(cmin, cmax);
    },
    currentItemsPage() {
      return this.currentx;
    },
    queriedItems() {
      return this.allMovements.length
    },
  },
  watch: {
    loading: function () {
      if (this.loading) {
        this.$vs.loading();
      }
      else {
        this.$vs.loading.close();
      }
    },
    periodType: async function (newval, old) {
      if (newval == "last") {
        var x = new Date();
        x.setDate(0); // 0 will result in the last day of the previous month
        this.startDate = new Date(x.getFullYear(), x.getMonth(), 1);
        this.endDate = new Date(x.getFullYear(), x.getMonth(), x.getDate());
      } else {
        this.startDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
        this.endDate = new Date();
      }
      if (old !== newval && newval != "custom") {
        await this.loadMovements();
      }
    }
  },
  methods: {
    setInitialDates() {
      this.startDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
      this.endDate = new Date();
    },
    async loadMovements() {
      // se genera log de accion
      if (this.isFirstTime) {
        this.saveInvestorLogAction("LC11-24");
        this.isFirstTime = false;
      }
      this.isMounted = false;
      this.loading = true;
      this.failed = false;
      try {
        let data = {
          start: this.startDate,
          end: this.endDate,
          // period: this.periodType
        }
        let url = `/api/v2/investor/${this.InvestorId}/movements-list-sm`;
        let response = await axios.post(url, data);
        this.allMovements = response.data;
      } catch (e) {
        this.failed = true;
      }
      this.isMounted = true;
      this.loading = false;
    },
    async datesChanged() {
      const valid = this.validateDates();
      if (valid) {
        await this.loadMovements(1);
        this.currentx = 1;
      }
    },
    async downloadCSV() {
      const valid = this.validateDates();
      if (!valid) {
        return;
      }
      try {
        const startYear = this.startDate.getFullYear();
        const startMonth = this.startDate.getMonth() + 1;
        const startDay = this.startDate.getDate();
        const endYear = this.endDate.getFullYear();
        const endMonth = this.endDate.getMonth() + 1;
        const endDay = this.endDate.getDate();
        let params = `startYear=${startYear}&startMonth=${startMonth}&startDay=${startDay}&endYear=${endYear}&endMonth=${endMonth}&endDay=${endDay}`;
        let url = `${this.ApiDomain}/api/v2/investor/${this.InvestorId}/movementsListCSV?access_token=${this.AccessToken}&${params}`;
        window.open(url, "_blank");
        // se genera log de accion
        this.saveInvestorLogAction("LC11-25");
      }
      catch (e) {
        this.warn(e)
      }
    },
    validateDates() {
      this.isInvalidRange = false;
      if (this.startDate > this.endDate) {
        this.isInvalidRange = true;
        this.errorNotifDialog("Aviso", "La fecha de inicio no puede ser mayor a la fecha de término.")
        return false;
      }
      const diffTime = Math.abs(this.startDate - this.endDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > this.maxRangeDays) {
        this.isInvalidRange = true;
        this.errorNotifDialog("Aviso", this.rangeError);
        return false;
      }
      return true;
    },
    async downloadVoucherRequest(tr){
      let url = `${this.ApiDomain}/api/v2/investor/operations/downloadVoucher/${tr.id}?access_token=${this.AccessToken}`;
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="css" scoped>
.options-display {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
</style>